import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";

export const LoanSummaryTable: React.FC<BaseTablePropsType> = ({ rows }) => {
    return (
        <BaseTable headers={[]}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row?.name?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{row?.value?.toString().split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
